import DynamicTable from '@atlaskit/dynamic-table';
import React from 'react';
import { formatAmount } from "../../PricingTab.utils";
import { PricingTierAmount as Amount, PricingTierList as List, PricingTierListItem as Item, PricingTierListItemContent as Content, PricingTierListItemHeader as Header, PricingTierRecurrence as Recurrence, PricingTierTableAmountCell as AmountCell, PricingTierTableCell as UnitCell } from "../PricingTiers.styles";
export const ServerDCTierUnit = ({
  item
}) => {
  const {
    floor,
    ceiling
  } = item;
  if (ceiling) {
    return "Up to ".concat(ceiling, " users");
  }
  return "".concat(floor, "+ users");
};
export const ServerDCTiersGrid = props => {
  const {
    items,
    currency
  } = props;
  return /*#__PURE__*/React.createElement(List, null, items.map((item, index) => {
    const amount = item.amount > 0 ? formatAmount(item.amount, {
      currency
    }) : 'Free';
    return /*#__PURE__*/React.createElement(Item, {
      key: index
    }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(ServerDCTierUnit, {
      item: item
    })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Amount, null, amount), /*#__PURE__*/React.createElement(Recurrence, null, "per year")));
  }));
};
const TABLE_HEADER = [{
  isSortable: false,
  key: 'ceiling',
  content: 'Team Size'
}, {
  isSortable: false,
  key: 'amount',
  content: /*#__PURE__*/React.createElement(AmountCell, null, "Annual Price")
}];
const getRows = (items, currency) => {
  return items.map(item => {
    const teamSize = {
      content: /*#__PURE__*/React.createElement(UnitCell, null, /*#__PURE__*/React.createElement(ServerDCTierUnit, {
        item: item
      }))
    };
    const annualPrice = {
      content: /*#__PURE__*/React.createElement(AmountCell, null, formatAmount(item.amount, {
        currency
      }))
    };
    return {
      cells: [teamSize, annualPrice]
    };
  });
};
export const ServerDCTiersTable = props => {
  const {
    items,
    currency
  } = props;
  return /*#__PURE__*/React.createElement(DynamicTable, {
    head: {
      cells: TABLE_HEADER
    },
    rows: getRows(items, currency)
  });
};